import { api } from './client'

export interface MfaStatus {
  has_totp: boolean
  has_passkey: boolean
  primary_type: 'PasswordMfa' | 'Password' | null
}

export interface TotpBeginResponse {
  session_token: string
  otpauth_url: string
  secret_b32: string
  algo: string
  digits: number
  step: number
  accountname: string
  issuer: string
}

export interface UserSecurityStatus {
  has_totp: boolean
  has_passkey: boolean
  primary_type: 'PasswordMfa' | 'Password' | null
}

export interface AdminResetTotpResponse {
  status: 'totp_reset'
  kanidm_removed: boolean
  sessions_revoked: number
  notified: {
    email: boolean
    whatsapp: boolean
    whatsapp_skip_reason: 'no_phone' | null
  }
}

export const mfaApi = {
  status: async (): Promise<MfaStatus> => {
    const r = await api.get<MfaStatus>('/v1/me/security/status')
    return r.data
  },
  totpBegin: async (password?: string): Promise<TotpBeginResponse> => {
    const r = await api.post<TotpBeginResponse>(
      '/v1/me/security/totp/begin',
      password ? { password } : {},
    )
    return r.data
  },
  totpVerify: async (sessionToken: string, code: number): Promise<void> => {
    await api.post('/v1/me/security/totp/verify', {
      session_token: sessionToken,
      code,
    })
  },
  totpCancel: async (sessionToken: string): Promise<void> => {
    await api.post('/v1/me/security/totp/cancel', {
      session_token: sessionToken,
    })
  },
  totpRemove: async (label: string): Promise<void> => {
    await api.delete('/v1/me/security/totp', { data: { label } })
  },
  getUserSecurity: async (userId: number): Promise<UserSecurityStatus> =>
    (await api.get(`/v1/users/${userId}/security`)).data,

  adminResetTotp: async (userId: number): Promise<AdminResetTotpResponse> =>
    (await api.post(`/v1/users/${userId}/totp/reset`)).data,
}
